import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/safeDig-en';
import es from './locales/safeDig-es';

Vue.use(VueI18n);

const SAFEDIG_LOCALE_KEY = 'safedig-locale';

export function getSavedLocale() {
  try {
    return localStorage.getItem(SAFEDIG_LOCALE_KEY) || 'en';
  } catch {
    return 'en';
  }
}

export function setSavedLocale(locale) {
  try {
    localStorage.setItem(SAFEDIG_LOCALE_KEY, locale);
  } catch (e) {
    console.warn('Could not save locale:', e);
  }
}

const i18n = new VueI18n({
  locale: getSavedLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    es
  }
});

export default i18n;
